module.exports = __webpack_public_path__ + "img/traegheit.0a7c608c.png";